// extracted by mini-css-extract-plugin
export default {"section":"container-scroll_section__B4ycN"};